import axios from 'axios'
const { VUE_APP_TF_EXPRESS_API } = process.env

const getBookingConditions = async (keyword, referer) => {
  const result = { error: false }
  try {
    const url = `${VUE_APP_TF_EXPRESS_API}/webdata/booking-conditions/${referer}/${keyword}`

    const result = await axios.get(url)

    if (result && result.data) {
      return result.data
    }
  } catch (err) {
    console.error('Error while getting booking conditions', err)
    result.error = true
    return result
  }
}

const getSupplierBookingConditions = async (cond_code, supplier_codes, referer, bookno) => {
  const result = { error: false }
  try {
    const url = `${VUE_APP_TF_EXPRESS_API}/webdata/supplier-booking-conditions/${cond_code}/${referer}`
    const body = { supplier_codes, bookno }
    const response = await axios.post(url, body)
    if (response && response.data) {
      return response.data
    }
  } catch (err) {
    console.error('Error while getting supplier booking conditions', err)
    result.error = true
    return result
  }
}

export {
  getBookingConditions,
  getSupplierBookingConditions
}